// extracted by mini-css-extract-plugin
module.exports = {"navArrow":"sO","navArrowSvg":"sP","wrapper":"sQ","reverse":"sR"};